import { SearchBarComponent } from './../../_component/search-bar/search-bar.component';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SegmentChangeEventDetail } from '@ionic/core';
import { PaginationColumn } from 'src/app/app/_component/pagination-client-side/pagination-column.class';
import { HeaderModel } from 'src/app/_component/header/header.model';
import { DateStiPipe } from 'src/app/_pipes/date-sti.pipe';
import { UserService } from 'src/app/_services';
import { HeaderService } from 'src/app/_services/header.service';
import { RowsLoaderService } from 'src/app/_services/rows-loader.service';
import { ThisPlatform } from '../../../_services/platform.service';
import { CompanyBasic } from '../../company/company.model';
import { CompanyService } from '../../company/company.service';
import { OrderViewComponent } from '../order-view/order-view.component';
import { Order, OrderViewMode } from '../_model/order.model';
import { OrderService } from '../_services/order.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-order-provider',
  templateUrl: './order-provider.page.html',
  styleUrls: ['./order-provider.page.scss'],
})
export class OrderProviderPage implements OnInit {
  columnsDefinition: PaginationColumn[] = [
    {
      name: 'id',
      displayName: 'ID',
      size: 1,
      sortable: true,
    },
    {
      name: 'dateCreated',
      displayName: 'MARKET.DATE',
      size: 3,
      sortable: true,
    },
    {
      name: 'companyProvider',
      displayName: 'MARKET.PROVIDER',
      size: 3,
      sortable: true,
      colValue: (row) => {
        return row.companyProvider.name;
      },
    },
    {
      name: 'orderCost',
      displayName: 'MARKET.COST',
      size: 2,
      sortable: true,
    },
    {
      name: 'status',
      displayName: 'MARKET.STATUS',
      size: 3,
      sortable: true,
    },
  ];

  rowsloader: RowsLoaderService;
  componentRef: any = OrderViewComponent;
  orderFilter: Order[] = [];
  orderViewMode: OrderViewMode = OrderViewMode.UserOrders;
  showLoader: boolean = true;

  companies: CompanyBasic[] = [];
  companiesFilter: CompanyBasic[];

  page: string;
  mobileSegments = [];
  headerInit: HeaderModel = {
    title: '',
    mobileSegmentsChangeFunc: (event) => this.mobileSegmentChanged(event),
    segments: [
      {
        name: 'MARKET.PROVIDERS',
        value: 'providers',
        permissionKeys: [''],
      },
      {
        name: 'MARKET.ORDERS',
        value: 'orders',
        permissionKeys: [''],
      },
    ],
    segmentsChangeFunc: (event) => this.setQueryParam(event.detail.value),
    showMobileSegmentsOnDesktop: true,
    shouldHasMobileSegments: true,
  };

  noCompanies: string;

  @ViewChild('search') search: SearchBarComponent;

  constructor(
    public orderServ: OrderService,
    public userServ: UserService,
    public companyServ: CompanyService,
    public activatedRoute: ActivatedRoute,
    private router: Router,
    public p: ThisPlatform,
    private headerServ: HeaderService,
    private translateServ: TranslateService,
  ) {}

  ngOnInit(): void {
    this.mobileSegments = [
      {
        name: 'MARKET.MY_ORDERS',
        value: OrderViewMode.UserOrders.toString(),
        permissionKeys: [''],
      },
      {
        name: 'MARKET.ORDERS_MY_COMPANY',
        value: OrderViewMode.CompanyOrders.toString(),
        permissionKeys: ['market.order.company.view'],
      },
      {
        name: 'MARKET.ORDER_SALL',
        value: OrderViewMode.AllOrders.toString(),
        permissionKeys: ['market.order.all.view'],
      },
    ];
    this.activatedRoute.queryParamMap.subscribe((params) => {
      if (params.get('section')) {
        const page = params.get('section');
        if (
          this.headerInit.segments.filter((el) => el.value == page).length > 0
        ) {
          this.page = params.get('section');
        } else {
          this.page = this.headerInit.segments[0].value;
          this.setQueryParam(this.page);
        }
      } else {
        this.page = this.headerInit.segments[0].value;
        this.setQueryParam(this.page);
        this.headerServ.setHeaderInit(this.headerInit);
      }
      if (this.page === 'providers') {
        if (!this.companies.length)
          this.companyServ
            .getCompaniesProvider()
            .subscribe((res: CompanyBasic[]) => {
              this.companies = res;
              this.companiesFilter = res;
            });

        this.headerInit.mobileSegments = [];
        this.headerInit.title = 'MARKET.PROVIDERS';
      } else {
        this.headerInit.mobileSegments = this.mobileSegments;
        this.headerInit.title = 'MARKET.ORDERS';
        this.onMyOrdersClick();
      }
    });
    this.noCompanies = this.translateServ.instant("MARKET.NO_COMPANIES");
  }
  ionViewWillEnter() {
    this.headerInit.activeSegment = this.page;
    this.headerServ.setHeaderInit(this.headerInit);
  }

  setQueryParam(page: string) {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        section: page,
      },
    });
  }

  onChangeSearchOrders(searchText: string) {
    this.orderFilter = this.orderServ.orders.filter((s) => {
      return (
        String(s.id) +
        ' ' +
        new DateStiPipe(this.userServ).transform(s.dateCreated) +
        ' ' +
        s.companyProvider.name +
        ' ' +
        s.orderCost +
        ' ' +
        s.description
      )
        .toUpperCase()
        .includes(searchText.toUpperCase());
    });
    this.rowsLoaderInit();
  }

  onChangeSearch(data) {
    this.companiesFilter = this.companies.filter((s) =>
      s.name.toUpperCase().includes(data.toUpperCase())
    );
  }

  onMyOrdersClick() {
    this.showLoader = true;
    this.orderServ
      .getOrdersByIdUser(this.userServ.userStorage.id)
      .subscribe((orders: Order[]) => {
        this.orderServ.orders = orders;
        this.orderFilter = orders;
        this.onChangeSearchOrders(
          this.search?.ngModel ? this.search.ngModel : ''
        );
        this.showLoader = false;
      });
  }

  onCompanyOrdersClick() {
    this.showLoader = true;
    this.orderServ
      .getOrdersByIdCompanyProvider(this.userServ.userStorage.idCompany)
      .subscribe((orders: Order[]) => {
        this.orderServ.orders = orders;
        this.orderFilter = orders;
        this.onChangeSearchOrders(
          this.search?.ngModel ? this.search.ngModel : ''
        );
        this.showLoader = false;
      });
  }

  onAllOrdersClick() {
    this.showLoader = true;
    this.orderServ.getOrders().subscribe((orders: Order[]) => {
      this.orderServ.orders = orders;
      this.orderFilter = orders;
      this.onChangeSearchOrders(
        this.search?.ngModel ? this.search.ngModel : ''
      );
      this.showLoader = false;
    });
  }

  mobileSegmentChanged(event: CustomEvent<SegmentChangeEventDetail>) {
    let i: number = +event.detail.value;

    if (i == OrderViewMode.UserOrders) {
      this.onMyOrdersClick();
    }

    if (i == OrderViewMode.CompanyOrders) {
      this.onCompanyOrdersClick();
    }

    if (i == OrderViewMode.AllOrders) {
      this.onAllOrdersClick();
    }
  }

  rowsLoaderServiceReady(loader: RowsLoaderService) {
    this.rowsloader = loader;
    this.rowsLoaderInit();
  }

  rowsLoaderInit() {
    if (this.rowsloader) {
      this.rowsloader.init(this.orderFilter);
    }
  }
}
